import $ from 'jquery'
window.$ = $;
window.jQuery = $;
$.extend({
	isObject : function(arg){
		return typeof arg == 'object';
	},
	copy : function(source){
		return $.extend(true, {}, source);
	},
	times : function(count, fn){
		if(isNaN(count))
			return;
		var i = 0;
		while(i < count){
			var r = fn(i);

			if(r === false)
				break;
			if(r === true)
				continue;
			i++;
		}
	},
	escape2Html(str) {
		var arrEntities={'lt':'<','gt':'>','nbsp':' ','amp':'&','quot':'"'};
		return str.replace(/&(lt|gt|nbsp|amp|quot);/ig,function(all,t){return arrEntities[t];});
	},
	chunk : function(arr, count){
		var result = [];
		for(var i = 0,len = arr.length; i < len; i += count){
		   result.push(arr.slice(i,i+count));
		}
		return result;
	},
	arc4random : function(max){
		return Math.floor(Math.random()*max);
	},
	randomArr : function(arr){
		return arr[$.arc4random(arr.length)];
	},
	// 循环格式化字符串
	repeat : function(source,args){
		if(!source || typeof source != 'object')
			return '';
		if(typeof args == 'function'){
			return this._repeat(source,args);
		}
		var con = '',
			len = source.length;
		$.each(source, function(i, d){
			if(!d)
				return true;
			var _con = '';
			$.each(args, function(j, e){
				_con += typeof e == 'function' ? e(d,i,len) : e;
			})
			con += _con;
		})
		return con;
	},
	_repeat : function(source, fn){
		var res = '';
		$.each(source, function(i, d){
			var _res = fn(i, d, source);
			if(typeof _res === 'boolean'){
				return _res;
			}
			res += _res;
		})
		return res;
	},
	// $.param() 后 转json对象
	toJson : function(str){
		var res = {};
		$.each(str.split('&'), function(i,d){
	        var e = d.split('=');
	        // 非对象
	        if(e.length == 1){
	        	res = str;
	        	return false;
	        }
	        res[e[0]] = e[1];
	    });
	    return res;
	},
	// 过滤空键值
	removeEmpty : function(param, copy){
		if(copy){
			param = $.copy(param);
		}
	    if(param){
	        for(var k in param){
	            if(param[k] === ''){
	                delete param[k];
	            }
	            for(var j in param[k]){
	                if(param[k][j] === ''){
	                    delete param[k][j];
	                }
	            }
	        };
	    }
	    return param;
	},
	// 保留中文
	toCN : function(str){
		return str.replace(/[^\u4e00-\u9fa5]/gi,"");
	},
	// 清空tips
	tips : function(){
		$('.ui-tips').remove();
	},
	itemTool : {
		isLeft : function(count, i){
			return !(i % count);
		},
		isRight: function(count, i){
			return !((i % count) - (count - 1));
		},
	},
	// cookie扩展
	cookie : {
		set : function(key,value,day){
			var Days = day || 3; 
		    var exp = new Date(); 
		    exp.setTime(exp.getTime() + Days*24*60*60*1000);
		    document.cookie = key + "="+ escape(value+'') + ";expires=" + exp.toGMTString()+";path=/";
		},
		get : function(key){
			var arr,reg = new RegExp("(^| )"+key+"=([^;]*)(;|$)");
		 
		    if(arr=document.cookie.match(reg)){
		    	return unescape(arr[2]); 
		    } else {
		    	return null; 
		    }
		},
		delete : function(key){
			if(!key){
				$.cookie.deleteAll();
				return;
			}
			var exp = new Date(); 
		    exp.setTime(exp.getTime() - 1); 
		    var cval=this.get(key); 
		    if(cval!=null){
		        document.cookie= key + "="+cval+";expires="+exp.toGMTString()+";path=/";
		    }
		},
		 //删除cookie中所有定变量函数    
       	deleteAll(){    
            var myDate=new Date();    
            myDate.setTime(-1000);//设置时间    
            var data=document.cookie;    
            var dataArray=data.split("; ");    
            for(var i=0;i<dataArray.length;i++){    
                 var varName=dataArray[i].split("=");    
                 document.cookie=varName[0]+"=''; expires="+myDate.toGMTString()+";path=/";
            }    
	    } 
	},
	modal : function(type, content, cantRemove){
		var fn = {
			pop : function(content){
				var $m = $("#sd_modal");
				var $c = $(content)
				.css({
					"display": "block",
		            "position": "fixed",
		            "opacity": 1,
		            "z-index": 110000,
		            "left": 50 + "%",
		            "top": 30  + "%"
				})
				.addClass('sd_modal_content');
				$m.after($c);
				// fix
				$c.css('margin-left', '-' + $c.outerWidth() / 2 + 'px');
				$("#sd_modal").css({ "display": "block", "opacity": 0 });
		        $("#sd_modal").fadeTo(200, 0.5);
			},
			close : function(){
				var $m = $("#sd_modal"),
					$c = $(".sd_modal_content");
				$m.remove();
				$c.remove();
			},
		}
		// 创建遮罩
		if(!$("#sd_modal").length){
			$('body').append(`<div id='sd_modal'></div>`);
			// 关闭
			if(!cantRemove){
				$('body').on('click', '#sd_modal', function(){
					// fn.close();
				})
			}
		}
		fn[type](content);
	}
})

$.fn.extend({
	replace : function(){
		var that = this,
			args = arguments,
			argCount = args.length;
		if(!argCount || argCount > 2){
			throw new Error('jqEx -------> arguments error!!!');
		}
		if(argCount === 2){
			return that.each(function(){
				$(args[0], that).empty().append(args[1]);
			})
		} else {
			return that.each(function(){
				$(this).empty().append(args[0]);
			})
		}
	},
	switchClass : function(str){
		this.addClass(str).siblings().removeClass(str);
		return this;
	},
	switchShow  : function(){
		this.show().siblings().hide();
	},
	// 获取元素对应父级item
	item   : function(key){
		if(this.attr(key))
			return this;
		return  this.parents('['+key+']:first');
	},
	// 获取父级id
	itemId : function(key){
		if(this.attr(key))
			return this.attr(key);
		return  this.parents('['+key+']:first').attr(key);
	},
	// tips标签
	tips : function(content,direction){
		// clear
		$('.ui-tips').remove();
		if(!content)
			return;
		// creat
		var temp = `<div class="ui-tips ui-tips-bottom ui-tips-x-center ui-tips-price-grid" style="z-index: 999;">
						<div class="ui-tips-main">${content}</div>
						<span class="ui-tips-arrow" style="z-index:999"></span>
					</div>`;
		this.each(function(i){
			var tips = $(temp),
				$this = $(this),
				height = $this.height(),
				offset = $this.offset();
			tips.appendTo('body');
			if(!direction || direction == 'top')
				tips.css({'z-index' : 999, top : (offset.top  - tips.height() - 5) + 'px', 'left' : (offset.left + ($this.width() - tips.width()) / 2 ) + 'px'});
			else if(direction == 'bottom')
				tips.addClass('rotate').css({'z-index' : 999, top : (offset.top + height + 10) + 'px', 'left' : (offset.left + ($this.width() - tips.width()) / 2 ) + 'px'});
			else if(direction == 'right')
				tips.addClass('point-right').css({'z-index' : 999, top : (offset.top  + ($this.height() - tips.height()) / 2 - 5) + 'px', 'left' : offset.left - tips.width() - 20 + 'px'})
		})
	},
	// 多行文本溢出
	overflowHidden:function(rows, lineHeight){
		// 需要显示多少行需要的高度
		var that = $(this);
		var maxHeight = lineHeight * rows;
		var text = that.text();
		var len = text.length;
		var temp = "", slen, tempStr;
		if(that.height()< maxHeight) {
			return;
		}else{
			that.text('');
			var i=0;
			while(that.height() < maxHeight){
				temp += text.substring(0, i+1);
				that.text(temp);
				i++
			}
		}
		slen = temp.length;
		tempStr = temp.substring(0, slen);
		that.text(tempStr+"...");
		that.height = maxHeight + 'px';
	}
})

// fix sort
!function(window) {
	var ua = window.navigator.userAgent.toLowerCase(),
		reg = /msie|applewebkit.+safari/;
	if (reg.test(ua)) {
		var _sort = Array.prototype.sort;
		Array.prototype.sort = function(fn) {
			if (!!fn && typeof fn === 'function') {
				if (this.length < 2) return this;
				var i = 0,
					j = i + 1,
					l = this.length,
					tmp, r = false,
					t = 0;
				for (; i < l; i++) {
					for (j = i + 1; j < l; j++) {
						t = fn.call(this, this[i], this[j]);
						r = (typeof t === 'number' ? t :
							!!t ? 1 : 0) > 0 ? true : false;
						if (r) {
							tmp = this[i];
							this[i] = this[j];
							this[j] = tmp;
						}
					}
				}
				return this;
			} else {
				return _sort.call(this);
			}
		};
	}
}(window);


// WEBPACK FOOTER //
// ./src/service/jqEx.js